import { api } from "@/lib/api";

// Opens an authenticated /api/files/{id} URL (image or PDF) in a new tab.
export async function openAuthFile(url) {
  try {
    const resp = await api.get(url.replace(/^\/api/, ""), { responseType: "blob" });
    window.open(URL.createObjectURL(resp.data), "_blank");
  } catch (err) {
    console.error("auth file open failed", err);
  }
}
